import { QUERY_KEYS } from '@/hooks/react-query/constants'
import { ECacheTime } from '@/lib/config/enum'
import { __cClubService } from '@/services/client/__c.club.service'
import { useQuery } from '@tanstack/react-query'
import { useUserQuery } from '../user/use-user'

export const useCoolClubMemberQuery = () => {
  const { data: user } = useUserQuery()
  return useQuery({
    // Dùng key thống nhất với SSR để Hydration hoạt động đúng
    queryKey: [QUERY_KEYS.COOL_CLUB_MEMBER],
    queryFn: async () => {
      try {
        // Quan trọng: API cần _id (Mongo) thay vì id; dùng _id để tránh null dữ liệu
        const res = await __cClubService.getCoolClubMember(user?._id ?? '')
        return res
      } catch (error) {
        console.error('🧙 ~ error:', error)
        return null
      }
    },
    refetchOnMount: false,
    staleTime: ECacheTime.THREE_HOURS,
    notifyOnChangeProps: 'all',
    // Khi user có _id (Mongo), query sẽ tự động chạy lại
    enabled: !!user?._id,
  })
}
